import React from "react";
import { PreviewPage } from "./PreviewPage";

export const SafetyPreviewPage = () => (
  <PreviewPage localStorageKey="sub-safety" />
);
